import { useGetStringMapsQuery } from '@/services/lookups/hooks';

interface StringMapLabelProps {
  value: number;
  objectTypeCode: number;
  attributeName: string;
  className?: string;
}

export const StringMapLabel = ({
  value,
  objectTypeCode,
  attributeName,
  className,
}: StringMapLabelProps) => {
  const { data: options = [] } = useGetStringMapsQuery({
    objectTypeCode,
    attributeName,
  });

  const option = options.find((opt) => Number(opt.attributeValue) === value);

  return <span className={className}>{option?.value || value}</span>;
};
